//import { enableProdMode } from '@angular/core';
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import { AppModule } from './app/app.module';

//// depending on the env mode, enable prod mode or add debugging modules
//if (process.env.ENV === 'build') {
//  enableProdMode();
//}

//export function main() {
//  return platformBrowserDynamic().bootstrapModule(AppModule).then(function(MODULE_REF) {   if (module["hot"]) {     module["hot"]["accept"]();          if (MODULE_REF.instance["hmrOnInit"]) {       module["hot"]["data"] && MODULE_REF.instance["hmrOnInit"](module["hot"]["data"]);     }     if (MODULE_REF.instance["hmrOnStatus"]) {       module["hot"]["apply"](function(status) {         MODULE_REF.instance["hmrOnStatus"](status);       });     }     if (MODULE_REF.instance["hmrOnCheck"]) {       module["hot"]["check"](function(err, outdatedModules) {         MODULE_REF.instance["hmrOnCheck"](err, outdatedModules);       });     }     if (MODULE_REF.instance["hmrOnDecline"]) {       module["hot"]["decline"](function(dependencies) {         MODULE_REF.instance["hmrOnDecline"](dependencies);       });     }     module["hot"]["dispose"](function(store) {       MODULE_REF.instance["hmrOnDestroy"] && MODULE_REF.instance["hmrOnDestroy"](store);       MODULE_REF.destroy();       MODULE_REF.instance["hmrAfterDestroy"] && MODULE_REF.instance["hmrAfterDestroy"](store);     });   }   return MODULE_REF; });
//}

//if (document.readyState === 'complete') {
//  main();
//} else {
//  document.addEventListener('DOMContentLoaded', main);
//}

////////////////////////////////////////////

import app = require("./app/app.module");
import $ = require("jquery");

import "hammerjs";

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { NgModuleFactoryLoader, SystemJsNgModuleLoader, NgModule, Injector, ErrorHandler } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from "@angular/common";
import { UpgradeModule } from "@angular/upgrade/static";

import { UIRouterUpgradeModule } from "@uirouter/angular-hybrid";
import { UrlService } from '@uirouter/core';
import { UIRouterModule } from '@uirouter/angular';

import { CoreModule } from "./app/core/core.module";
import { AllMaterialModule } from "./app/all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import SharedModule from "./app/shared/shared.module";
import { ResourcesModule } from "./app/resources/resources.module";
import SettingsModule from "./app/settings/settings.module";
import HomeModule from "./app/home/home.module";
import { DashboardModule } from "./app/dashboard/dashboard.module";
import { ActivitiesModule } from "./app/activities/activities.module";
import { ComplianceModule } from "./app/compliance/compliance.module";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiService } from './app/shared';
import { MatDatepickerModule, MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from "@angular/material";

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MOMENT_DATE_FORMATS } from "./app/shared/MomentDateAdapter";
import { Ng2Webstorage } from "ngx-webstorage";
import { AuthInterceptor } from "./app/blocks/interceptor/auth.interceptor";
import { CrewErrorHandler } from "./app/core/crew-error-handler";
import { CrewPermissionsService } from "./app/core/crew-permissions.service";
import { PasswordModule } from "./app/password/password.module";

export function getHttpService($injector) {
    return $injector.get('$http');
}

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        UpgradeModule,
        HttpClientModule,
        UIRouterModule,
        UIRouterUpgradeModule,
        MatNativeDateModule,
        MatDatepickerModule,
        AllMaterialModule,
        FlexLayoutModule,
        CoreModule,
        SharedModule,
        HomeModule,
        PasswordModule,
        ActivitiesModule,
        SettingsModule,
        DashboardModule,
        ComplianceModule,
        ResourcesModule,
        MatDatepickerModule,
        MatNativeDateModule,
        Ng2Webstorage.forRoot({ prefix: 'crew', separator: '-' }),
    ],
    providers: [
        ApiService,
        { provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader },
        { provide: '$http', deps: ['$injector'], useFactory: getHttpService },
        //{ provide: MAT_DATE_LOCALE, useValue: 'da-DK' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
            deps: [Injector]
        },
        { provide: ErrorHandler, useClass: CrewErrorHandler, deps: [Injector] },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
        { provide: DateAdapter, useClass: MomentDateAdapter },
        CrewPermissionsService,
    ]
})

export class AppModule {
    ngDoBootstrap() { }

    // TODO: Create the Shell as an Angular 2 Component, and use the following code!
    //constructor(public appRef: ApplicationRef) { }
    //hmrOnInit(store) {
    //    console.log('HMR store', store);
    //}
    //hmrOnDestroy(store) {
    //    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    //    // recreate elements
    //    store.disposeOldHosts = createNewHosts(cmpLocation);
    //    // remove styles
    //    removeNgStyles();
    //}
    //hmrAfterDestroy(store) {
    //    // display new elements
    //    store.disposeOldHosts();
    //    delete store.disposeOldHosts;
    //}
}

$(() => {
    // Manually bootstrap the Angular app
    platformBrowserDynamic().bootstrapModule(AppModule).then(function(MODULE_REF) {   if (module["hot"]) {     module["hot"]["accept"]();          if (MODULE_REF.instance["hmrOnInit"]) {       module["hot"]["data"] && MODULE_REF.instance["hmrOnInit"](module["hot"]["data"]);     }     if (MODULE_REF.instance["hmrOnStatus"]) {       module["hot"]["apply"](function(status) {         MODULE_REF.instance["hmrOnStatus"](status);       });     }     if (MODULE_REF.instance["hmrOnCheck"]) {       module["hot"]["check"](function(err, outdatedModules) {         MODULE_REF.instance["hmrOnCheck"](err, outdatedModules);       });     }     if (MODULE_REF.instance["hmrOnDecline"]) {       module["hot"]["decline"](function(dependencies) {         MODULE_REF.instance["hmrOnDecline"](dependencies);       });     }     module["hot"]["dispose"](function(store) {       MODULE_REF.instance["hmrOnDestroy"] && MODULE_REF.instance["hmrOnDestroy"](store);       MODULE_REF.destroy();       MODULE_REF.instance["hmrAfterDestroy"] && MODULE_REF.instance["hmrAfterDestroy"](store);     });   }   return MODULE_REF; }).then(platformRef => {
        var appModule = app.initialize();
        const otherwiseConfigBlock = ['$urlRouterProvider', $urlRouterProvider => { $urlRouterProvider.otherwise("/home"); }];
        appModule.config(otherwiseConfigBlock);

        const injector: Injector = platformRef.injector;
        const upgrade = injector.get(UpgradeModule) as UpgradeModule;

        // Manually bootstrap the AngularJS app
        upgrade.bootstrap(document.body, ["app"]);

        // Intialize the Angular Module (get() any UIRouter service from DI to initialize it)
        const url: UrlService = injector.get(UrlService);

        // Instruct UIRouter to listen to URL changes
        url.listen();
        url.sync();
    });
});


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/main.ts